import { PrintOrientation } from '../types';
import { defaultStyles } from './defaultPrintStyles';
import { insertHeadElement } from './insertHeadElement';

/** Injects the default styles into the printBody as a style tag with media attributes */

const injectDefaultPrinterStyles = (
  printBody: Document,
  orientation: PrintOrientation = 'portrait'
) => {
  return insertHeadElement({
    printBody,
    tagName: 'style',
    text: defaultStyles(orientation),
    media: 'print',
  });
};

export { injectDefaultPrinterStyles };
